import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EDITION_FORMULAS, editionConfiguratorHref } from "@/lib/editionFormulas";

/**
 * Grille publique des 6 formules « Mise en page & édition ».
 * Utilisée par Services (Découvrir les prestations) et Tarifs.
 * Chaque carte affiche la formule de calcul (pas de « À partir de X € ») et
 * envoie vers le configurateur avec le mode présélectionné.
 */
export default function EditionFormulaCards({ variant = "grid", testIdPrefix = "edition-card" }) {
  const isDense = variant === "dense";
  const gridClass = isDense
    ? "grid md:grid-cols-2 gap-6"
    : "grid md:grid-cols-2 lg:grid-cols-3 gap-6";

  return (
    <div className={gridClass} data-testid="edition-formula-grid">
      {EDITION_FORMULAS.map((f) => (
        <Link
          key={f.type}
          to={editionConfiguratorHref(f.type)}
          className="cs-card p-8 flex flex-col justify-between min-h-[300px] group"
          data-testid={`${testIdPrefix}-${f.type}`}
        >
          <div>
            <h3 className="cs-h3 text-2xl leading-tight">{f.name}</h3>
            <p className="mt-3 text-[14px] text-neutral-700 leading-relaxed">{f.desc}</p>

            <div className="mt-6 border-t border-black/10 pt-4">
              <div className="cs-eyebrow text-neutral-500 mb-2">Tarif</div>
              <ul className="space-y-1.5">
                {f.formula.map((row, i) => (
                  <li
                    key={i}
                    className={`flex items-start gap-2 text-[14px] leading-snug ${
                      row.highlight ? "text-black font-medium" : "text-neutral-700"
                    }`}
                  >
                    {row.highlight && (
                      <span className="inline-block h-1.5 w-1.5 bg-[#0E7C90] mt-2 shrink-0" />
                    )}
                    <span className={row.highlight ? "" : "pl-3.5"}>{row.line}</span>
                  </li>
                ))}
              </ul>
              {f.note && (
                <p className="mt-3 text-[12px] font-mono text-neutral-500 leading-relaxed">{f.note}</p>
              )}
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-black/15 flex items-center justify-between">
            <span className="font-mono text-[13px] uppercase tracking-[0.14em] group-hover:text-[#0E7C90] transition-colors">
              Calculer mon tarif
            </span>
            <ArrowUpRight size={18} className="group-hover:text-[#0E7C90] transition-colors" />
          </div>
        </Link>
      ))}
    </div>
  );
}
